import Section from '@/components/ui/Section';
import styled from 'styled-components';

export const StyledCTA = styled(Section)`
  text-align: center;
  padding: 88px 0 0 0;
  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    padding: 64px 0 0 0;
  }

  h2 {
    padding-bottom: 24px;

    @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
      font-size: 48px;
      line-height: 56px;
      letter-spacing: -1px;
      padding-bottom: 16px;
    }
    @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
      font-size: 28px;
      line-height: 32px;
      letter-spacing: -0.5px;
    }
  }
`;

export const GradientContainer = styled.div`
  position: relative;
  width: 100vw;
  height: 100%;
  z-index: 1;
`;

export const Wrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  pointer-events: none;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    display: none;
  }
`;

export const GradientImage = styled.img`
  width: 100%;
  min-width: 1280px;
  height: auto;
  max-height: 100%;
  object-fit: contain;
  object-position: bottom center;

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    display: none;
  }
`;
